import React from "react";
import { PhoneIcon } from "@heroicons/react/solid";

function About() {
	return (
		<section id='about'>
			<div className='container mx-auto flex flex-col md:flex-row items-center px-5 xl:px-40 py-28'>
				<div className='flex md:flex-1 flex-col md:items-start md:text-left mb-16 md:mb-0 text-center'>
					<p className='text-lg md:text-xl text-gray-200 font-mono font-semibold'>
						HI THERE! I'M
					</p>
					<p className='text-3xl md:text-4xl font-sarif text-gray-200 font-extrabold mb-3'>
						<span className='text-yellow-500'>PRANAV</span> MENE
					</p>
					<p className='text-md md:text-lg leading-relaxed md:mr-10'>
						I like to craft solid and interactive web applications with great
						user experiences.
					</p>
					<div className='flex justify-center flex-row mt-12'>
						<a
							href='#contact'
							className='bg-gradient-to-r from-pink-500 to-yellow-500 items-center inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-sm md:text-lg'
						>
							Get In Touch
							<PhoneIcon className='h-5 w-5 ml-2' />
						</a>
						<a
							href='#projects'
							className='ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-sm md:text-lg'
						>
							My Projects
						</a>
					</div>
				</div>
				<div className=''>
					<img
						style={{ boxShadow: "5px 5px 35px #D78112" }}
						className='lg:block hidden mx-auto object-cover object-top w-80 h-80 rounded-full pointer-events-none select-none'
						alt='hero_image'
						src='./projectImages/dp1.jpg'
					/>
				</div>
			</div>
		</section>
	);
}

export default About;
